import React from 'react';
import _ from 'lodash';
import { Button, Box, Stack, Typography, Select, MenuItem } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import store from '../../../../../services/redux-store';

import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { submitSunActiveCategoryAction } from '../../../../../services/request';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';

export const SunActiveCategoryForm = props => {
  const { data, submitCallback, handleClose, choices } = props;

  const { loading, mutate } = useMutation(submitSunActiveCategoryAction);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const state = store.getState();

  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste'),
    type: Yup.number().required('To pole nie może być puste'),
    value: Yup.number()
      .nullable()
      .optional()
  });
  const initialValues = {
    name: data ? data.name || '' : '',
    type: data ? data.type : null,
    value: data ? data.value : null,
    season: data ? data.season : state.app.season
  };

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.id : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano imprezę' : 'Dodano nową imprezę', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się ${data ? 'edytować' : 'dodać nowej'} imprezy`);
      setMessage(payload);
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.id);
    if (!error) {
      submitCallback(data, 'delete', 'success', `Usunięto impreze ${data.name}`, '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się usunąć imprezy ${data.name}`);
      setMessage(payload.toString());
      setShowAlert(true);
    }
  };

  const formik = useFormik({
    enableReinitialize: data ? true : false,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
        <Stack direction="row" mt={1} p={1} spacing={2}>
          <Box display="flex" flexDirection="column" flex="1">
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Nazwa</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="name"
                id="name"
                type="text"
                placeholder="nazwa kategorii"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Rodzaj</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 90%' }}
                select
                name="type"
                placeholder="grupa imprezowa"
                options={choices.type}
                value={formik.values.type}
                onChange={formik.handleChange}
                error={formik.touched.type && Boolean(formik.errors.type)}
                helperText={formik.touched.type && formik.errors.type}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 10%">Wartość</Typography>
              <DebounceInput
                sx={{ flex: '1 1 90%' }}
                name="value"
                id="value"
                type="number"
                placeholder="Jeśli brak pozostaw puste"
                value={formik.values.value}
                onChange={e => {
                  const val = e.target.value;
                  formik.setFieldValue('value', val === '' ? null : Number(val));
                }}
                error={formik.touched.value && Boolean(formik.errors.value)}
                helperText={formik.touched.value && formik.errors.value}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
          </Box>
        </Stack>

        <Button
          color="primary"
          variant="contained"
          type="submit"
          sx={{ mt: 3 }}
          disabled={loading}
        >
          <AddIcon />
          Zapisz
        </Button>
        { data
          ? <Button
            color="error"
            variant="contained"
            sx={{ mt: 3, ml: 4 }}
            onClick={() => {
              setConfirmDeleteOpen(true);
            }}
            disabled={loading}
          >
            <DeleteIcon />
          Usuń
          </Button>
          : null}
      </form>
      <ConfirmDialog
        title="Usunąć kategorię?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
        disabled={loading}
      >
        Czy na pewno chcesz usunąć tą kategorię?
      </ConfirmDialog>
    </>

  );
};
